import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";

export type RailQueryParams = {
  number: SearchReferenceDTO;
  carrier_code?: string;
};
